import React, { useRef, useEffect } from "react";
import styles from "./NavBar.module.scss";

const NavBar = ({setIsActive, isActive, myPerson, setInfoReady}) => {
    const navRef = useRef(null);

    const sectionsConfig = [
        { name: "Resumen", shortName: "Resumen" },
        { name: "Productos/Servicios", shortName: "Productos/Servicios" },
        { name: "Calificaciones", shortName: "Calificaciones" },
        { name: "Proyectos publicados", shortName: "Proyectos" },
        { name: "Cotización de materiales", shortName: "Materiales" },
        /* { name: "Documentaciones de obra", shortName: "Documentación", condition: myPerson }, */
        { name: "Accesos a obras", shortName: "Accesos", condition: myPerson },
    ];

    const sections = sectionsConfig.filter((section) => {
        const hasCondition = section.hasOwnProperty('condition');
        return !hasCondition || section.condition === true;
    });

    useEffect(() => {
        if (isActive && navRef.current) {
            const activeButton = navRef.current.querySelector(`.${styles.navBar_button_active}`);
            if (activeButton) {
                centerActiveButton(activeButton);
            }
        }
    }, [isActive]);

    const centerActiveButton = (buttonElement) => {
        if (!navRef.current || !buttonElement) return;
        
        const nav = navRef.current;
        const navRect = nav.getBoundingClientRect();
        const buttonRect = buttonElement.getBoundingClientRect();
        
        // Calcular la posición para centrar el botón
        const buttonCenter = buttonRect.left + buttonRect.width / 2;
        const navCenter = navRect.left + navRect.width / 2;
        const scrollOffset = buttonCenter - navCenter;
        
        // Hacer scroll suave hacia la posición calculada
        nav.scrollBy({
            left: scrollOffset,
            behavior: 'smooth'
        });
    };

    const handleClick = (section, buttonElement) => {
        setInfoReady(false);
        setIsActive(section);
        
        setTimeout(() => {
            centerActiveButton(buttonElement);
        }, 100);
    };


    
    return (
        <div className={styles.navBar}>
            <div className={styles.navBar_wrapper}>
                <nav ref={navRef} className={styles.navBar_nav}>
                    {sections.map((section, index) => (
                        <button 
                            key={index} 
                            className={`${styles.navBar_button} ${isActive === section.name && styles.navBar_button_active}`}
                            onClick={(e) => handleClick(section.name, e.currentTarget)}
                            title={section.name}
                        >
                            <span className={styles.buttonText}>{section.shortName}</span>
                        </button>
                    ))}
                </nav>
            </div>
        </div>
    );
};

export default NavBar;